// PrimeReact's own defaults are English strings baked into each component's
// defaultProps ("No records found", "No results found"), and they surface in
// every dropdown and every table that does not pass its own message. Rather
// than add the same prop to a hundred call sites, the defaults themselves are
// translated here, once, before anything renders.
//
// Imported for its side effect from index.js. Any component that passes its
// own `emptyMessage` (SelectEmpty, EmptyState, TableWait) still wins.
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { DataTable } from "primereact/datatable";
import { AutoComplete } from "primereact/autocomplete";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import ReactDOM from "react-dom";

const set = (Component, defaults) => {
  if (!Component) return;
  Component.defaultProps = { ...(Component.defaultProps || {}), ...defaults };
};

set(Dropdown, {
  emptyMessage: "مفيش عناصر هنا",
  emptyFilterMessage: "مفيش نتيجة للبحث ده",
});

set(MultiSelect, {
  emptyMessage: "مفيش عناصر هنا",
  emptyFilterMessage: "مفيش نتيجة للبحث ده",
  selectedItemsLabel: "{0} عناصر مختارة",
});

set(DataTable, {
  emptyMessage: "مفيش بيانات",
});

set(AutoComplete, {
  emptyMessage: "مفيش نتيجة للبحث ده",
});

set(Calendar, {
  locale: Calendar.defaultProps ? Calendar.defaultProps.locale : undefined,
});

// Every page renders its <Toast /> inside its own markup, so the toast lives in the page's stacking context and
// a dialog's mask (rendered on <body>) covers and blurs it whatever its z-index. Rendering every toast straight
// into <body> puts it in the same context as the dialogs, where its z-index wins; refs and show() are unchanged.
const toastRender = Toast.prototype.render;
Toast.prototype.render = function () {
  return ReactDOM.createPortal(toastRender.call(this), document.body);
};
